export default __webpack_public_path__ + "static/media/electro-3000.2ef781e8.svg";